import { getOne } from './get-one'
import { getList } from './get-list'
import { updateOne } from './update-one'

export default { getOne, getList, updateOne }
